var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"menu-loader"},[_c('b-row',{staticClass:"text-center"},[_c('b-spinner',{attrs:{"variant":"danger","label":"Spinning"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }